import { useEffect } from "react";
import { t } from "@/i18n-js/instance";
import { BillingCurrency } from "@/react/components/SettingsApp/Plan/RegularPlan/BillingCurrency";
import { BillingCycle } from "@/react/components/SettingsApp/Plan/RegularPlan/BillingCycle";
import { usePunditUserContext } from "@/react/contexts";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { usePlans } from "@circle-react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import Features from "./Features";
import { PlanSelector } from "./PlanSelector";
import { TopSection } from "./TopSection";

const localeRoot = "pricing_plans.plan_settings.plan_selection";

export const PlansPageVariantA = () => {
  const { currentCommunity } = usePunditUserContext();
  const { isCurrentPlanLoading } = usePlans();

  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_page.visited", {});
  }, []);

  if (isCurrentPlanLoading || !currentCommunity) {
    return <Loader variant="fullscreen" />;
  }

  return (
    <div className="flex flex-col gap-10">
      <TopSection />
      <div>
        <div className="flex flex-row flex-wrap items-center justify-between">
          <Typography.TitleSm weight="semibold">
            {t([localeRoot, "title"])}
          </Typography.TitleSm>

          <div className="flex items-center">
            <BillingCurrency />
            <BillingCycle />
          </div>
        </div>

        <PlanSelector />
      </div>
      <Features />
    </div>
  );
};
